/**
 * Single source of truth for languages the admin UI supports.
 * Order matters — PL is the default and renders first everywhere.
 *
 * The `languages` table in DB may contain extra rows (e.g. for currency/site
 * configuration); the admin UI deliberately ignores those and only edits/displays
 * content for the codes listed here.
 */
export type LangCode = 'pl' | 'en' | 'de' | 'cs';

export const SUPPORTED_LANGS: LangCode[] = ['pl', 'en', 'de', 'cs'];

export const DEFAULT_LANG: LangCode = 'pl';

// NOTE: flag emoji were removed on purpose — Windows has no flag-emoji glyphs
// (they render as bare letter pairs). Flags are rendered by
// `@/components/FlagIcon` from vendored Twemoji SVGs instead.

export const LANG_NAMES: Record<LangCode, string> = {
  pl: 'Polski',
  en: 'English',
  de: 'Deutsch',
  cs: 'Čeština',
};

export function isSupportedLang(code: string): code is LangCode {
  return (SUPPORTED_LANGS as string[]).includes(code);
}
